<div class="public-container">
  <div class="left-side-container">
    <!-- Logo container -->
    <figure>
      <img src="assets/images/logo.svg" alt="SBI" />
    </figure>

    <!-- Main form -->
    <form
      *ngIf="!(invalidPasswordRecoveryKey$ | async)"
      [formGroup]="passwordRecoveryForm"
      (submit)="onUserSubmit()"
    >
      <h2 class="public-form-title">Cambiar contraseña</h2>
      <p>Para recuperar el acceso a tu cuenta, ingresá una nueva contraseña.</p>

      <!-- Password -->
      <div
        class="input-container"
        [class.error]="
          passwordRecoveryForm.get('password').touched &&
          passwordRecoveryForm.get('password').invalid
        "
      >
        <span class="label">Nueva contraseña</span>

        <div class="input">
          <input
            (keyup)="setPasswordValue($event)"
            formControlName="password"
            type="password"
            placeholder="Nueva contraseña"
          />
          <i class="fas fa-key"></i>
        </div>

        <ng-container *ngIf="passwordRecoveryForm.get('password').touched">
          <span
            *ngIf="passwordRecoveryForm.get('password').hasError('required')"
            class="status-message"
            >Debes ingresar una contraseña</span
          >
          <span
            *ngIf="passwordRecoveryForm.get('password').hasError('minlength')"
            class="status-message"
          >
            Debe de tener al menos
            {{
              passwordRecoveryForm.get('password').errors.minlength
                .requiredLength
            }}
            caracteres
          </span>
          <span
            *ngIf="passwordRecoveryForm.get('password').hasError('serverError')"
            class="status-message"
          >
            {{ serverErrorMessage }}
          </span>
        </ng-container>
      </div>

      <!-- Password Repeat -->
      <div
        class="input-container"
        [class.error]="
          passwordRecoveryForm.get('passwordRepeat').touched &&
          passwordRecoveryForm.get('passwordRepeat').invalid
        "
      >
        <span class="label">Reingresar contraseña</span>

        <div class="input">
          <input
            (keyup)="setPasswordRepeatValue($event)"
            formControlName="passwordRepeat"
            type="password"
            placeholder="Reingresar contraseña"
          />
          <i class="fas fa-key"></i>
        </div>

        <ng-container
          *ngIf="passwordRecoveryForm.get('passwordRepeat').touched"
        >
          <span
            *ngIf="
              passwordRecoveryForm.get('passwordRepeat').hasError('required')
            "
            class="status-message"
            >Debes ingresar una contraseña</span
          >
          <span
            *ngIf="
              !passwordRecoveryForm
                .get('passwordRepeat')
                .hasError('required') &&
              passwordRecoveryForm.get('passwordRepeat').hasError('nomatch')
            "
            class="status-message"
            >Las contraseñas no coinciden</span
          >
        </ng-container>
      </div>

      <!-- Button -->
      <button
        class="button"
        [class.loading]="passwordChanging$ | async"
        [disabled]="passwordRecoveryForm.invalid || (passwordChanging$ | async)"
      >
        Recuperar contraseña
        <i class="fas fa-check"></i>
      </button>
    </form>

    <!-- Invalid password key -->
    <div
      *ngIf="invalidPasswordRecoveryKey$ | async"
      class="invalid-password-key"
    >
      <p class="error">
        El tiempo para cambiar su contraseña ha expirado, solicite nuevamente un
        cambio de contraseña
      </p>

      <!-- Button -->
      <button routerLink="/" class="button">
        Volver al login
        <i class="fas fa-arrow-right"></i>
      </button>
    </div>

    <!-- Footer -->
    <footer>© 2020 Todos los derechos reservados.</footer>
  </div>
</div>
